import type { IPartner, IResponseWithLoading } from "App/Modules/Models";
import type { IPartnersRepository } from "App/Modules/Repositories";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class PartnerDetailsReactWrapperController {
    public static $inject: string[] = ["mmPartnersRepository"];

    public partnerId: string;

    // Set by transition
    public partner: IResponseWithLoading<IPartner>;
    public errorResponse: IResponseWithLoading<void>;

    constructor(private readonly partnersRepository: IPartnersRepository) {}

    public $onInit() {
        extendWithLoadingAndFail(this.partnersRepository.getPartner(this.partnerId), 0).subscribe(
            (response) => {
                if (!response.hasError && response.data) {
                    this.partner = response;
                }
            },
            (error) => {
                this.errorResponse = error;
            },
        );
    }
}
